/* eslint-disable */
import { ANALYTIC_EVENTS, SEARCH_OVERLAY_ACTION } from 'ggApp/modules/gaAnalytics/constants';
import { user as userSelector } from 'ggApp/modules/auth/selectors';
import { query as querySelector } from 'ggApp/modules/search/selectors';
import { createSelector } from 'reselect';
import { getListNameByRoute } from 'ggApp/modules/gaAnalytics/utils';
import {
    locationPathname as locationPathnameSelector,
    params as paramsSelector,
} from 'ggApp/modules/router/selectors';

export const searchOverlayEventSelector = (eventAction, product = null) =>
    createSelector(
        userSelector,
        querySelector,
        locationPathnameSelector,
        paramsSelector,
        (user, query, pathname, routeParams) => {
            const eventProperty = {
                user_id: (user && user.id) || null,
                ...(eventAction !== SEARCH_OVERLAY_ACTION.enter && { search_term: query || null }),
                ...(eventAction === SEARCH_OVERLAY_ACTION.productClick &&
                    product && {
                        productSKU: product.sku,
                        product_name: product.name,
                    }),
            };
            const eventLabel = getListNameByRoute(pathname, routeParams);
            return {
                event: ANALYTIC_EVENTS.gtmEvent,
                eventCategory: 'search',
                eventLabel,
                eventAction,
                eventProperty,
            };
        },
    );
